import * as headers from "../operations/hide_headers";

export function hideHeaders(state, page){
	headers.hideHeaders(this, state, page);
}